import React from "react";
import { useTranslation } from "react-i18next";

const Modal = ({ isOpen, close, children }) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  /* helper so clicks inside the white panel don’t bubble to the overlay */
  const stop = (e) => e.stopPropagation();

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 999,
      }}
      /*  ——►  overlay NO LONGER closes the modal  ◄—— */
      /* onClick={close} */
    >
      <div
        onClick={stop}
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "white",
          borderRadius: "10px",
          width: "90%",
          maxWidth: "500px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* top strip */}
        <div
          style={{
            height: "40px",
            backgroundColor: "rgba(252, 132, 68, 0.7)",
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
          }}
        />

        {/* close icon */}
        <button
          onClick={close}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            background: "none",
            border: "none",
            fontSize: "1.5rem",
            cursor: "pointer",
            color: "white",
          }}
        >
          ×
        </button>

        {/* body */}
        <div style={{ padding: "20px" }}>
          {children}

          {/* action buttons */}
          <div style={{ display: "flex", gap: "20px", marginTop: "20px" }}>
            {/* 1) STATION booking — disabled */}
            <button
              className="thm-btn"
              disabled          // ← disables clicks & adds aria-disabled
              style={{
                opacity: 0.5, // visual cue
                cursor: "not-allowed",
              }}
            >
              {t("book")}     {/* keep label for consistency */}
            </button>

            {/* 2) HOME booking — still active */}
            <a href="/daba" style={{ textDecoration: "none" }}>
              <button
                className="thm-btn"
                style={{
                  backgroundColor: "#0072ce",
                  color: "#fff",
                  border: "none",
                  padding: "10px 20px",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                {t("book1")}
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
